<ion-header>
  <ion-toolbar color="light">
    <ion-button fill="clear" slot="start">
      <ion-title>
        <b>{{ 'schedule.textFlexPlannen' | translate }}</b>
      </ion-title>
    </ion-button>
    <ion-button fill="clear" (click)="dismiss()" slot="end" [attr.aria-label]="'ariaLabel.closeButton' | translate">
      <ion-icon icon="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (courseDetail) {
    <div class="flexible-plan-main-container ion-padding">
      <div class="flexible-plan-with-possible-timeslot ion-padding-horizontal">
        <ion-select
          id="flexible-plan-select-year"
          [(ngModel)]="academicYear"
          interface="popover"
          placeholder="{{ 'schedule.selectYearFlex' | translate }}"
          (ionChange)="startYearChanged(academicYear)"
        >
          @for (courseYear of courseDetail.courseYears; track courseYear.academicYear) {
            <ion-select-option [value]="courseYear.academicYear">
              {{ 'schedule.labelAcademicYear' | translate }} {{ courseYear.yearNr }} ({{
                courseYear.academicYearDescription
              }})
            </ion-select-option>
          }
        </ion-select>

        @if (selectedYearFlexibleTimeslots.length) {
          <div class="timeslots">
            @for (timeslot of selectedYearFlexibleTimeslots; track timeslot) {
              <pa-timeslot class="timeslot-spacing" [timeslot]="timeslot" />
            }
          </div>
        }
      </div>

      <div class="flexible-plan-container">
        <!--Columns for period per study year -->
        @for (period of selectedYearCoursePeriods; track period.periodNr) {
          <div class="pa-plan-header-period">{{ period.periodDescription }}</div>
        }

        @for (period of selectedYearCoursePeriods; track period.periodNr) {
          <div
            class="pa-plan-grid pa-plan-grid-hoverable"
            (click)="selectPeriod(selectedYear, period)"
            (keydown.enter)="selectPeriod(selectedYear, period)"
            tabindex="0"
            role="button"
          >
            @if (!selectedYear?.flexiblePlanCourse) {
              <!-- this academic year the course can not be planned flexible -->
              @if (period.offered) {
                <div class="timeslots">
                  @if (period.timeslots.length) {
                    @for (timeslot of period.timeslots; track timeslot) {
                      <pa-timeslot class="timeslot" [timeslot]="timeslot" />
                    }
                  } @else {
                    <pa-timeslot class="timeslot timeslot-empty" />
                  }
                </div>
              }
            } @else {
              <!-- this academic year the course can be planned flexible -->
              <div class="timeslots">
                <ion-checkbox
                  [id]="'flexible-plan-select-period-' + period.periodNr"
                  [checked]="checkedSelectedPeriods[period.periodNr]"
                  class="timeslot-empty timeslot-checkbox ion-focusable"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</ion-content>

@if (selectedYear?.flexiblePlanCourse) {
  <ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
      <ion-button
        id="flexible-plan-confirm-selection-button"
        class="confirm-button"
        (click)="confirmFlexiblePeriodsSelection()"
        [disabled]="selectedPeriods.length === 0"
        fill="solid"
        color="success"
        slot="end"
      >
        {{ 'label.ok' | translate }}
      </ion-button>
    </ion-toolbar>
  </ion-footer>
}

<ng-template [ngxPermissionsExcept]="Role.EMPLOYEE_VIEWS_STUDENT_PLAN">
  @if (showMoveToPlanLaterButton && courseData.isMovableToPlanLater) {
    <ion-footer>
      <ion-toolbar class="ion-padding-horizontal">
        <ion-button class="confirm-button" (click)="moveToPlanLater()" fill="clear" color="primary" slot="start">
          {{ 'schedule.toPlanLater' | translate }}
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  }
</ng-template>
